import { storage } from '../storage';
import type { AuthService, User } from './authService';

const ID_KEY = 'pa.anon.id';
const NAME_KEY = 'pa.anon.name';

/** Anonymous, no-signup auth. A stable device-local id is generated once and
 *  persisted; the chosen name is remembered for next time. */
export class AnonymousAuthService implements AuthService {
  private user: User | null = null;

  constructor() {
    const id = storage.get(ID_KEY);
    const name = storage.get(NAME_KEY);
    if (id) this.user = { id, name: name ?? '', anonymous: true };
  }

  currentUser(): User | null {
    return this.user;
  }

  async signInAnonymous(name: string): Promise<User> {
    let id = storage.get(ID_KEY);
    if (!id) {
      id = `anon_${Math.abs(hashString(name + ':' + performance.now())).toString(36)}`;
      storage.set(ID_KEY, id);
    }
    storage.set(NAME_KEY, name);
    this.user = { id, name, anonymous: true };
    return this.user;
  }

  signOut(): void {
    this.user = null;
  }
}

function hashString(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  return h;
}
